const convertAbsolutesToCSS = (absolutes) => ({
    '--absolute-white-base-default': absolutes.white.base.default,
    '--absolute-white-base-action': absolutes.white.base.action,
    '--absolute-white-base-active': absolutes.white.base.active,
    '--absolute-white-base-action-active': absolutes.white.base.activeAction,
    '--absolute-white-text-default': absolutes.white.text.default,
    '--absolute-white-text-action': absolutes.white.text.action,
    '--absolute-white-text-active': absolutes.white.text.active,
    '--absolute-white-text-active-action': absolutes.white.text.activeAction,
    '--absolute-black-base-default': absolutes.black.base.default,
    '--absolute-black-base-action': absolutes.black.base.action,
    '--absolute-black-base-active': absolutes.black.base.active,
    '--absolute-black-base-action-active': absolutes.black.base.activeAction,
    '--absolute-black-text-default': absolutes.black.text.default,
    '--absolute-black-text-action': absolutes.black.text.action,
    '--absolute-black-text-active': absolutes.black.text.active,
    '--absolute-black-text-active-action': absolutes.black.text.activeAction,
});
const convertAbsolutesToObject = (absolutes) => ({
    absoluteWhiteBaseDefault: absolutes.white.base.default,
    absoluteWhiteBaseAction: absolutes.white.base.action,
    absoluteWhiteBaseActive: absolutes.white.base.active,
    absoluteWhiteBaseActionActive: absolutes.white.base.activeAction,
    absoluteWhiteTextDefault: absolutes.white.text.default,
    absoluteWhiteTextAction: absolutes.white.text.action,
    absoluteWhiteTextActive: absolutes.white.text.active,
    absoluteWhiteTextActiveAction: absolutes.white.text.activeAction,
    absoluteBlackBaseDefault: absolutes.black.base.default,
    absoluteBlackBaseAction: absolutes.black.base.action,
    absoluteBlackBaseActive: absolutes.black.base.active,
    absoluteBlackBaseActionActive: absolutes.black.base.activeAction,
    absoluteBlackTextDefault: absolutes.black.text.default,
    absoluteBlackTextAction: absolutes.black.text.action,
    absoluteBlackTextActive: absolutes.black.text.active,
    absoluteBlackTextActiveAction: absolutes.black.text.activeAction,
});
const Absolutes = {
    white: {
        base: {
            default: 'var(--absolute-white-base-default)',
            action: 'var(--absolute-white-base-action)',
            active: 'var(--absolute-white-base-active)',
            activeAction: 'var(--absolute-white-base-action-active)',
        },
        text: {
            default: 'var(--absolute-white-text-default)',
            action: 'var(--absolute-white-text-action)',
            active: 'var(--absolute-white-text-active)',
            activeAction: 'var(--absolute-white-text-active-action)',
        },
    },
    black: {
        base: {
            default: 'var(--absolute-black-base-default)',
            action: 'var(--absolute-black-base-action)',
            active: 'var(--absolute-black-base-active)',
            activeAction: 'var(--absolute-black-base-action-active)',
        },
        text: {
            default: 'var(--absolute-black-text-default)',
            action: 'var(--absolute-black-text-action)',
            active: 'var(--absolute-black-text-active)',
            activeAction: 'var(--absolute-black-text-active-action)',
        },
    },
};

export { Absolutes, convertAbsolutesToCSS, convertAbsolutesToObject };
